import { render } from "./Companion.vue?vue&type=template&id=73d73d68&scoped=true"
import script from "./Companion.vue?vue&type=script&lang=js"
export * from "./Companion.vue?vue&type=script&lang=js"

import "./Companion.vue?vue&type=style&index=0&id=73d73d68&scoped=true&lang=scss"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73d73d68"]])

export default __exports__